export default {
  templates: {
    // Traditional Wedding Tasks
    'choose-venue': {
      title: 'Empfangsort wählen',
      description: 'Verschiedene Orte für Zeremonie und Empfang recherchieren und besuchen'
    },
    'define-budget': {
      title: 'Gesamtbudget definieren',
      description: 'Detailliertes Budget für jeden Ausgabenposten erstellen'
    },
    'choose-date': {
      title: 'Datum wählen',
      description: 'Hochzeitsdatum basierend auf Verfügbarkeit von Ort und Hauptanbietern festlegen'
    },
    'book-venue': {
      title: 'Empfangsort buchen',
      description: 'Ort für Zeremonie und Empfang besuchen und buchen'
    },
    'choose-photographer': {
      title: 'Fotograf wählen',
      description: 'Fotografen recherchieren und treffen, um den für Ihre Hochzeit auszuwählen'
    },
    'choose-caterer': {
      title: 'Catering wählen',
      description: 'Catering für den Empfang recherchieren und auswählen'
    },
    'choose-florist': {
      title: 'Florist wählen',
      description: 'Florist für Zeremonie- und Empfangsdekorationen auswählen'
    },
    'choose-music': {
      title: 'Musik wählen',
      description: 'Musiker oder DJ für Zeremonie und Empfang auswählen'
    },
    'choose-transport': {
      title: 'Transport wählen',
      description: 'Transport für den Hochzeitstag buchen'
    },
    'choose-attire': {
      title: 'Hochzeitskleidung wählen',
      description: 'Hochzeitskleid und Anzug des Bräutigams einkaufen'
    },
    'choose-beauty': {
      title: 'Schönheitsdienste wählen',
      description: 'Frisur- und Make-up-Services für den Hochzeitstag buchen'
    },
    'send-invitations': {
      title: 'Einladungen versenden',
      description: 'Hochzeitseinladungen entwerfen und an Gäste versenden'
    },
    'plan-honeymoon': {
      title: 'Flitterwochen planen',
      description: 'Flitterwochenziel recherchieren und buchen'
    },
    'legal-formalities': {
      title: 'Rechtliche Formalitäten',
      description: 'Alle rechtlichen Anforderungen für die Ehe erfüllen'
    }
  }
};
